"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.toggleButtonVariants = exports.ToggleButton = void 0;
const TogglePrimitive = __importStar(require("@radix-ui/react-toggle"));
const class_variance_authority_1 = require("class-variance-authority");
const React = __importStar(require("react"));
const utils_1 = require("../../lib/utils");
const defaultStyles = "tw-inline-flex tw-items-center tw-justify-center tw-gap-1 tw-whitespace-nowrap tw-rounded-md tw-text-sm tw-font-semibold tw-transition-colors";
const activeStyles = "active:tw-bg-neutral-500 active:tw-text-white";
const disabledStyles = "disabled:tw-bg-primaryDim-50 disabled:tw-text-neutral-300 disabled:tw-pointer-events-none";
const focusStyles = "focus-visible:tw-outline-none focus-visible:tw-ring-1 focus-visible:tw-ring-ring";
const colorStyles = "tw-bg-primary-50 hover:tw-bg-primary-100 tw-text-neutral-500";
const stateStyles = "data-[state=on]:tw-bg-secondary-300 data-[state=on]:hover:tw-bg-secondary-500 data-[state=on]:tw-text-white";
const toggleButtonVariants = (0, class_variance_authority_1.cva)([
    defaultStyles,
    activeStyles,
    disabledStyles,
    focusStyles,
    colorStyles,
    stateStyles,
], {
    variants: {
        size: {
            sm: "tw-h-6 tw-min-w-6 tw-px-1",
            md: "tw-h-7 tw-min-w-7 tw-px-1",
            lg: "tw-h-8 tw-min-w-8 tw-px-1",
        },
    },
    defaultVariants: {
        size: "md",
    },
});
exports.toggleButtonVariants = toggleButtonVariants;
const ToggleButton = React.forwardRef(({ className, size, ...props }, ref) => (React.createElement(TogglePrimitive.Root, { ref: ref, className: (0, utils_1.cn)(toggleButtonVariants({ size, className })), ...props })));
exports.ToggleButton = ToggleButton;
ToggleButton.displayName = "ToggleButton";
